import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getProductLedgerReport,
  getProductLedgerNext,
  getProductLedgerPrevious,
  getProductLedgerParticularPage,
} from "./thunk";

// initialState
const initialState = {
  productLedgers: [],
  loadingData: false,
  loading: false,
  count: 0,
  pageNo: 1,
  previous: null,
  next: null,
};

//
export const productLedgerSlice = createSlice({
  name: "productLedger",
  initialState,
  reducers: {
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    clearProductLedger: (state) => {
      state.loading = false;
    },
  },

  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        getProductLedgerReport.pending,
        getProductLedgerParticularPage.pending,
        getProductLedgerPrevious.pending,
        getProductLedgerNext.pending
      ),
      (state) => {
        state.loading = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getProductLedgerReport.fulfilled,
        getProductLedgerParticularPage.fulfilled,
        getProductLedgerPrevious.fulfilled,
        getProductLedgerNext.fulfilled
      ),
      (state, action) => {
        state.loading = false;
        state.productLedgers = action.payload?.data;
        state.count = action.payload?.totalCount;
        state.previous = action.payload?.previous;
        state.next = action.payload?.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getProductLedgerReport.rejected,
        getProductLedgerParticularPage.rejected,
        getProductLedgerPrevious.rejected,
        getProductLedgerNext.rejected
      ),
      (state) => {
        state.loading = false;
      }
    );
  },
});

export const { goToPage, clearProductLedger } = productLedgerSlice.actions;

export default productLedgerSlice.reducer;
